<template>
	<transition name="slide-fade">
		<div class="modal-container">
			<div v-if="actionType === 'story-control'" class="modal" @click.stop>
				<ion-icon class="megaphone" name="ios-megaphone"></ion-icon>
				<div class="modal-header">
					<div class="modal-title">
						<span>Hi Stranger!</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<p>You are not signed in</p>
					<p>Sign in or create an account to {{action}} this story</p>
				</div>
				<div class="modal-footer">
					<button class="button stackng-button" @click="redirect">Take me there!</button>
				</div>
			</div>
			<div v-else-if="actionType === 'delete-account'" class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span>Hi {{this.$store.state.user.user.firstName}}!</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<p>We will miss you!</p>
					<p>Are you sure you want to delete your account?</p>
				</div>
				<div class="modal-footer">
					<button class="button delete-button" @click="deleteAccount">Yes, I am sure</button>
					<button class="button stackng-button" @click="closeModal">No</button>
					<span class="delete-message" v-if="deleteMessage !== null">{{deleteMessage}}</span>
				</div>
			</div>
			<div v-else-if="actionType === 'verify-email'" class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span>Hi {{this.$store.state.user.user.firstName}}!</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="goHome"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<p>
						<ion-icon class="info-icon" name="information-circle-outline"></ion-icon>Email verification required
					</p>
					<p>
						Click the button below to resend the email verification link.
						Follow the instructions in the email to complete verification.
						If you have verified your email, please refresh the page.
					</p>
				</div>
				<div class="modal-footer">
					<email-verification-button></email-verification-button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import firebase from "firebase/app";
import { db } from "../../resources/firebase";
import { updateGroupAdmin } from "../../api/groups";
import { groupsMixin } from "../../mixins/groupsMixin";
import "firebase/auth";
import EmailVerificationButton from "../buttons/EmailVerificationButton.vue";

export default {
	mixin: [groupsMixin],
	data() {
		return {
			deleteMessage: null
		};
	},
	components: {
		EmailVerificationButton
	},
	computed: {
		action() {
			return this.$store.getters.getAccountModal.action;
		},
		actionType() {
			if (
				this.action === "share" ||
				this.action === "like" ||
				this.action === "save"
			) {
				return "story-control";
			} else if (this.action === "delete") {
				return "delete-account";
			} else if (this.action === "verify-email") {
				return "verify-email";
			}
		}
	},
	mounted() {
		if (this.actionType !== "verify-email") {
			const modalContainer = document.querySelector(".modal-container");
			modalContainer.addEventListener("click", this.closeModal);
		}
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				action: ""
			};
			this.$store.commit("updateAccountModal", payload);
		},
		redirect() {
			this.closeModal();

			//Route to authentication
			setTimeout(() => {
				this.$router.push({ path: `/auth` });
			}, 400);
		},
		goHome() {
			this.$router.push({ path: "/" });

			setTimeout(() => {
				this.closeModal();
			}, 400);
		},
		deleteAccount() {
			let user = firebase.auth().currentUser;
			const deleteButton = document.querySelector(".delete-button");
			deleteButton.classList.add("is-loading");

			db.collection("users")
				.doc(user.uid)
				.update({
					deleted: true
				})
				.then(docRef => {
					//Re-assign group admin to another user
					db.collection("users")
						.doc(user.uid)
						.get()
						.then(doc => {
							user
								.delete()
								.then(() => {
									// Remove deleted user from the all groups they're in
									let groups = doc.data().groups;
									const authUser = this.$store.state.user.authUser.uid;

									groups.forEach(group => {
										db.collection("users")
											.doc(authUser)
											.update({
												groups: firebase.firestore.FieldValue.arrayRemove(group)
											})
											.then(() => {
												//Remove user from group members
												// BUG: This doesnt get called (firebase error insufficent permissions)
												db.collection("test_groups")
													.doc(group)
													.update({
														members: firebase.firestore.FieldValue.arrayRemove(
															authUser
														)
													})
													.catch(() => {
														// console.log(error);
														throw new Error(error);
													});
											})
											.catch(error => {
												// console.log(error);
												throw new Error(error);
											});
									});
								})
								.then(async () => {
									//Change the group admin to the next member in the group
									if (doc.data().groups && doc.data().groups.length > 0) {
										await updateGroupAdmin(doc.data().groups, user.uid);
									}
								})
								.then(() => {
									setTimeout(() => {
										deleteButton.classList.remove("is-loading");

										//Show toast
										this.$toasted.show(`Delete successful`, {
											theme: "bubble",
											position: "bottom-center",
											duration: 2500
										});

										this.closeModal();
										//Sign user out so the store object resets
										this.$store.dispatch("signOut");
										this.$router.push({ path: `/auth` });
									}, 1000);
								})
								.catch(error => {
									// console.log(error);
									setTimeout(() => {
										deleteButton.classList.remove("is-loading");
										this.deleteMessage = error.message;
									}, 1000);
									throw new Error(error);
								});
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				})
				.catch(error => {
					// console.log(error);

					//Show toast
					this.$toasted.show(`An error occured`, {
						theme: "bubble",
						position: "bottom-center",
						duration: 2500,
						className: ["error-toast"]
					});

					deleteButton.classList.remove("is-loading");
					throw new Error(error);
				});
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<!--<style lang="scss" scoped>
	@import "../../styles/modalStyles.scss";
</style>-->
<style scoped>
.modal {
	height: 330px;
}

.modal-header {
	height: 10%;
	margin-bottom: 0px;
}

.modal-body {
	height: 65%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 10;
}

.modal-body,
.modal-footer {
	text-align: center;
}

.modal-body p:first-of-type {
	display: flex;
	align-items: center;
	margin-right: 5px;
	font-size: 23px;
	font-weight: bold;
	margin-bottom: 20px;
}

.modal-body p:last-of-type {
	font-size: 15px;
	color: #b7b7b7;
}

.modal-footer {
	/* margin-top: 20px; */
	height: 25%;
}

.megaphone {
	font-size: 300px;
	opacity: 0.15;
	position: absolute;
	/* color: #fff; */
	margin: 0;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%) rotate(20deg); /* IE 9 */
	-webkit-transform: translate(-50%, -50%) rotate(20deg); /* Safari 3-8 */
	transform: translate(-50%, -50%) rotate(20deg);
}

button {
	font-size: 15px;
}

.delete-message {
	font-size: 11px;
	margin: 10px auto;
	width: 80%;
	display: block;
}

.info-icon {
	font-size: 23px;
	margin-right: 5px;
}

@media only screen and (max-width: 540px) {
	.modal-body p:first-of-type {
		font-size: 25px;
	}

	.modal-body p:last-of-type {
		font-size: 13px;
	}

	.megaphone {
		font-size: 550px;
	}

	.delete-message {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AccountModal.vue